import react from "react";
import * as ui from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import * as auth from "../../auth";
import * as rest from "../../rest";
import { definitions } from "../../schema/api";
import { resources, controls } from "../../const/resource";
import { RecordList } from "../../components/record_list";
import { Loading } from "../../components/loading";

import NoteAdd from "@material-ui/icons/NoteAdd";

const labels: { [key: string]: string } = {
  name: "企業名",
  nameKana: "企業名カナ",
  notFound: "まだ登録されていません",
  create: "新規登録",
};

type RetrieveState = {
  initialized: boolean;
  clientCompanies: definitions["ClientCompany"][];
};

function Retrieve() {
  const navigate = useNavigate();
  const [state, setState] = react.useState<RetrieveState>({
    initialized: false,
    clientCompanies: [],
  });

  const onRowClicked = auth.isAuthorized(
    resources.client_company.identifier,
    auth.resourceCrudFlag.update
  )
    ? (clientCompany: definitions["ClientCompany"]) => {
      navigate(`/${resources.client_company.identifier}/${controls.update.identifier}/${clientCompany.id}`);
      }
    : undefined;

  react.useEffect(() => {
    if (!state.initialized) {
      state.initialized = true;

      new rest.ClientCompany()
        .getAll(auth.getToken())
        .then((json: definitions["ClientCompany"][]) => {
          state.clientCompanies = json;
          setState({ ...state });
        });
    }
  });

  if (!state.initialized) {
    return <Loading />;
  }

  return (
    <ui.Container>
      <ui.Grid container spacing={4}>
        <ui.Grid item xs={12}></ui.Grid>
        <ui.Grid item xs={12}>
          {auth.isAuthorized(
            resources.client_company.identifier,
            auth.resourceCrudFlag.create
          ) && (
            <ui.Box
              display="flex"
              alignItems="center"
              justifyContent="flex-end"
              height="100%"
            >
              <ui.IconButton
                onClick={(e: any) =>
                  (window.location.href = `/${resources.client_company.identifier}/${controls.create.identifier}`)
                }
              >
                <NoteAdd />
                <ui.Typography variant="body2">{labels.create}</ui.Typography>
              </ui.IconButton>
            </ui.Box>
          )}
        </ui.Grid>
        <ui.Grid item xs={12}>
          <RecordList<definitions["ClientCompany"]>
            defaultText={labels.notFound}
            cols={[
              { label: labels.name, key: "name" },
              { label: labels.nameKana, key: "name_kana" },
            ]}
            items={state.clientCompanies}
            onRowClicked={onRowClicked}
          />
        </ui.Grid>
      </ui.Grid>
    </ui.Container>
  );
}

export { Retrieve };
